import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';
import {AccessService} from '../services/access.service';

@Component({
    selector: 'app-data-management',
    templateUrl: './data-management.component.html',
    styleUrls: ['./data-management.component.css']
})
export class DataManagementComponent implements OnInit {
    token;

    constructor(private authService: AuthenticationService,
                private accessService: AccessService) {
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    canAccessOutgoingStudent() {
        return this.accessService.canAccessOutgoingStudent();
    }

    canAccessPOC() {
        return this.accessService.canAccessPOC();
    }

    canAccessIncomingStudent() {
        return this.accessService.canAccessIncomingStudent();
    }

    isLoggedIn(): boolean {
        return this.authService.isLoggedIn();
    }

    ngOnInit() {
        if (this.isLoggedIn()) {
            this.token = this.authService.getToken();
        }
    }

}
